import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import * as d3 from 'd3';

@Component({
  selector: 'awair-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss']
})
export class LegendComponent implements OnInit, OnChanges {
  @Input() name: string;
  @Input() index: number;

  color: string = '';
  dash: string = '';

  lineColorList: string[] = ['#66A7FF', '#AA76F1', '#60DAEF', '#EC8AD0', '#7FB6FF', '#BC8BFF', '#4CE5FF', '#FF9DE3'];

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propname in changes) {
      if (propname === 'index') {
        if (this.index === -1) {
          // For total avg.
          this.dash = '2';
          this.color = '#ACB4BB';
        } else {
          // For the rest,
          this.dash = this.index > 3 ? '4,2,4,2' : '';
          this.color = this.lineColorList[this.index];
        }
      }
    }
  }
}
